import { useContext } from "react";

import { ProjectContext } from "@/stores/project-provider";

export const useProjectBounds = (): [number, number, number, number] | null => {
  const project = useContext(ProjectContext);

  if (project.location) {
    return [
      project.location.coordinates[0] - 0.05,
      project.location.coordinates[1] - 0.05,
      project.location.coordinates[0] + 0.05,
      project.location.coordinates[1] + 0.05,
    ];
  }

  return null;
};
